const _ = require("lodash");

const entryStudentPages = ["home.main"];

// Returns an array, possibly empty, of bundles to load through Bundles.js when
// the given page is shown to the user. Modules required to show the page don't
// need to be returned; this is just for indicating what to preload in advance.
const getPreloadList = function(page) {
	//On any "entry" student page, load all current student bundles:
	if (_.includes(entryStudentPages, page.name)) {
		return ["trainer", "library", "profile", "theater"];
	}
	//On any of trainer, profile, library, load the other two bundles:
	if (/^trainer\./.test(page.name)) {
		return ["library", "profile", "theater"];
	}
	if (/^profile\./.test(page.name)) {
		return ["trainer", "library", "theater"];
	}
	if (/^library\./.test(page.name)) {
		return ["trainer", "profile", "theater"];
	}
	if (/^theater\./.test(page.name)) {
		return ["trainer", "profile", "library"];
	}
	return [];
};

module.exports = {
	getPreloadList,
};
